import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'secondsToDuration'
})
export class SecondsToDurationPipe implements PipeTransform {

    transform(seconds: any): string {
        if(seconds < 0){
            seconds = 0;
        }
        const hours = ("0" + Math.floor( seconds / 3600 )).slice(-2);
        const mins = ("0" + Math.floor( (seconds - (+hours * 3600) ) / 60)).slice(-2);
        const secs = ("0" + Math.floor( seconds % 60 )).slice(-2);
        return hours+':'+mins+':'+secs;
    }

}


// WEBPACK FOOTER //
// ./src/app/pipes/seconds-to-duration.pipe.ts